<template>
  <el-form inline size="mini" :model="formData" ref="form">
    <div class="card-title">
      <span>合同附件</span>
      <el-link type="primary" style="float: right;font-size: 12px;margin-right: 30px;" @click="toWorkbenchContract">
        合同工作台
      </el-link>
    </div>
    <div class="form-card" :class="{disabled}"
         style="display: flex;justify-content: space-between;align-items: center;">
      <el-select v-model="formData.covenant_id" placeholder="输入系统编号/合同标题关键词检索选择" filterable default-first-option remote
                 size="mini" style="width: calc(100% - 180px);" :remote-method="handelRemote" clearable>
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.covenant_title"
            :value="item.id">
          <span style="color: #8492a6; font-size: 13px">「{{ item.covenant_no }}」</span>
          <span>{{ item.covenant_title }}</span>
        </el-option>
        <el-option disabled value="">
          <span style="color: #8492a6; font-size: 12px"> <i class="el-icon-info" /> 输入系统编号/合同标题关键词检索选择（最多显示20条）</span>
        </el-option>
      </el-select>
      <span class="handel-span" v-if="userAuth.can_store_covenants" @click="handelAdd">无匹配的合同附件？点击添加</span>
    </div>

    <contract-store ref="ContractStore" @success="callbackSuccessStore"
                    :fix-customer="{customer_id:formData.customer_id,customer_name:formData.customer_name}"/>
  </el-form>
</template>

<script>
import {orderCovenantOptions} from "@/api/orderCovenant";
import ContractStore from "@/views/workbench/Contract/contractStore.vue";

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const creator_id = user.id

export default {
  name: "PartCovenant",
  components: {ContractStore},
  props: {
    formData: {
      type: Object,
      required: true
    },
    editField: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  watch: {
    "formData.customer_id"() {
      this.handelRemote()
    }
  },
  methods: {
    toWorkbenchContract() {
      const {href} = this.$router.resolve({
        name: `WorkbenchContract`,
      });
      window.open(href, "_blank");
    },
    async callbackSuccessStore(id) {
      await this.handelRemote()
      this.formData.covenant_id = id
    },
    handelAdd() {
      if (!this.formData.customer_id) {
        this.$message.warning('请先选择客户！')
        return false;
      }
      this.$refs.ContractStore.dialogStore = true
    },
    async handelRemote(query) {
      const {customer_id} = this.formData
      if (!customer_id) {
        return false;
      }
      const response = await orderCovenantOptions({creator_id, customer_id, value: query,})
      this.options = response.data || []
    }
  }
}
</script>

<style lang="scss" scoped>
.handel-span {
  width: 160px;
  color: #ff3176;
  cursor: pointer;
}
</style>